import { observable } from "mobx";
import { createAccount, fetchRealnameInfo, fetchAccountInfo, fetchSalaryAccountInfo, contractSignDetail, fetchUserSettleStatus, fetchConfirmRealnameResult, employerList } from '@/services/user';
import { getActionQueueStr } from '@/utils/settle-process';

// 用户信息
const user = observable({
  employerBindList: [],
  contractSignDetailList: [],
  // 实名
  realnameInfo: {},
  // 账户
  accountInfo: {
    certAuditStatus: '',
    certName: '',
    certNo: '',
    currTenantEntId: '',
    currTenantEntName: '',
    mobileNo: '',
    registerTime: '',
    status: '',
    tenantId: '',
    tenantUserId: '',
    userId: ''
  },
  // 开通账号结果
  result: {},
  // 佣金结算账户信息
  salaryAccountInfo: {},
  // 入驻状态
  settleStatus: {
    realnameStatus: '',
    accountStatus: '',
    openStatus: '',
    settleCardStatus: '',
    certAuditStatus: '',
    isCompleted: false,
  },
  // 更新实名信息
  updateRealnameInfo(payload) {
    const { certNo, certName, certType, realname } = payload || {};
    this.realnameInfo = {
      realname,
      certNo,
      certName,
      certType
    };
  },
  updateEmployerList(payload) {
    this.employerBindList = payload || [];
  },
  updatecontractSignDetailList(payload) {
    this.contractSignDetailList = payload || [];
  },
  // 更新账户信息
  updateAccountInfo(payload) {
    const { certNo, certName, mobileNo, status,
      registerTime, userId, certAuditStatus, currTenantEntId,
      currTenantEntName,
    } = payload || {};
    this.accountInfo = {
      certNo,
      certName,
      mobileNo,
      status,
      registerTime,
      userId,
      certAuditStatus,
      currTenantEntId,
      currTenantEntName,
      registered: !!userId // 是否开通账号的标识符
    }
  },
  // 更新佣金结算账户信息
  updateSalaryAccountInfo(payload) {
    const { salaryAccountType, salaryAccountNo, bankCode, bankName } = payload || {};
    this.salaryAccountInfo = {
      salaryAccountType,
      salaryAccountNo,
      bankCode,
      bankName,
      hasSalary: salaryAccountNo ? true : false // 是否有结算信息的标识符
    };
  },
  // 更新账号开通结果
  updateCreateResultInfo(payload) {
    const { res } = payload || {};
    this.result = res;
  },
  // 更新入驻状态
  updateSettleStatus(payload) {
    const { realnameStatus, settleCardStatus, accountStatus, openStatus, certAuditStatus, todoList, isCompleted } = payload || {};
    this.settleStatus = {
      realnameStatus, openStatus, settleCardStatus, accountStatus, certAuditStatus, todoList, isCompleted
    }
  },

  // 获取入驻状态
  async getSettleStatus(payload) {
    const res = await fetchUserSettleStatus(payload) || {};
    // 得出操作队列
    const todoList = getActionQueueStr(res);
    let isCompleted = true;
    const settleCheckKeys = ['realnameStatus', 'settleCardStatus', 'certAuditStatus', 'openStatus'];
    settleCheckKeys.forEach((key) => {
      if(res[key] !== 1) {
        isCompleted = false;
      }
    });
    this.updateSettleStatus({ ...res, todoList, isCompleted });
  },
  // 获取实名信息
  async getRealnameInfo(payload) {
    const { realname, certNo, certName } = await fetchRealnameInfo(payload) || {};
    this.updateRealnameInfo({ realname, certNo, certName });
    return { realname, certNo, certName };
  },
  async employerList(payload) {
    const { item } = await employerList(payload) || {};
    this.updateEmployerList(item);
  },
  async contractSignDetail(payload) {
    const data = await contractSignDetail(payload) || {};
    this.updatecontractSignDetailList(data);
  },
  // 确认实名信息
  async confirmRealnameInfo(payload) {
    await fetchConfirmRealnameResult(payload);
  },
  // 获取账户信息
  async getAccountInfo(payload) {
    const res = await fetchAccountInfo(payload);
    this.updateAccountInfo({ ...res });
    return res;
  },
  // 获取佣金结算账户信息
  async getSalaryAccountInfo(payload) {
    const res = await fetchSalaryAccountInfo(payload);
    this.updateSalaryAccountInfo({ ...res });
  },
  // 开通灵工账号
  async registerAccount(payload) {
    const header = payload.header || {};
    delete payload.header;
    const res = await createAccount(payload, header);
    this.updateCreateResultInfo({ ...res });
  }
});

export default user;
